import { useAtomValue } from "jotai";
import React from "react";
import styled from "styled-components";
import { bookmarkStore, continuekStore } from "@stores/bookdata";
import anime from "animejs/lib/anime.es.js";
import { useRef } from "react";

const Wrap = styled.div`
  position: fixed;
  width: 100px;
  left: 30px;
  top: 50%;
  padding: 10px 0;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
`;
const BoxWrap = styled.div`
  width: 100px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Box = styled.button`
  width: 100%;
  height: 100%;
  position: relative;

  &:after {
    content: "";
    display: block;
    width: 53px;
    height: 53px;
    margin-left: 24px;
    border-radius: 8px;
    background-color: ${({ color }) => color};
    transition: all 0.3s;
  }
  &:before {
    content: "";
    position: absolute;
    display: block;
    width: 64px;
    height: 64px;
    opacity: 0;
    transform: scale(0);
    left: 18px;
    top: 9px;
    box-sizing: border-box;
    border-radius: 10px;
    border: 5px solid #fff;
    transition: all 0.3s;
  }

  &.on {
    &:after {
      width: 33px;
      height: 33px;
      margin-left: 34px;
    }
    &:before {
      content: "";
      position: absolute;
      opacity: 1;
      transform: scale(1);
      display: block;
      width: 64px;
      height: 64px;
      left: 18px;
      top: 9px;
      box-sizing: border-box;
      border-radius: 10px;
      border: 5px solid #fff;
    }
  }
`;

const BookmarkBox = styled.button`
  width: 100%;
  height: 100%;
  position: relative;
  &:after {
    content: "";
    display: block;
    width: 53px;
    height: 53px;
    margin-left: 24px;
    border-radius: 8px;
    background: url(${require("@assets/img/icon_sidebar_bookmark.png")})
      no-repeat;
    background-size: 100%;
    transition: all 0.2s;
  }

  &.continue-icon {
    &:after {
      content: "";
      display: block;
      width: 53px;
      height: 53px;
      margin-left: 24px;
      border-radius: 8px;
      background: url(${require("@assets/img/icon_sidebar_continue.png")})
        no-repeat;
      background-size: 100%;
      transition: all 0.2s;
    }
  }

  &.on {
    &:after {
      width: 33px;
      height: 33px;
      margin-left: 34px;
    }
    &:before {
      content: "";
      position: absolute;
      opacity: 1;
      transform: scale(1);
      display: block;
      width: 64px;
      height: 64px;
      left: 18px;
      top: 9px;
      box-sizing: border-box;
      border-radius: 50%;
      border: 5px solid #fff;
    }
  }
`;

const GoTop = styled.button`
  width: 100%;
  height: 100%;
  position: relative;
  &:after {
    content: "";
    display: block;
    width: 54px;
    height: 54px;
    margin-left: 24px;
    border-radius: 8px;
    background: url(${require("@assets/img/up1_s.png")}) no-repeat;
    background-size: 100%;
  }
`;

const MainSideBar = () => {
  const curBookMark = useAtomValue(bookmarkStore);
  const continueData = useAtomValue(continuekStore);
  const bookmarkRef = useRef(null);
  const continueRef = useRef(null);

  const activeClass = (num) => {
    const ar = document.querySelectorAll(".rbox");
    if (num === "bookmark") {
      bookmarkRef.current && bookmarkRef.current.classList.add("on");
      continueRef.current && continueRef.current.classList.remove("on");
      ar.forEach((el, i) => el.classList.remove("on"));
    } else if (num === "continue") {
      bookmarkRef.current && bookmarkRef.current.classList.remove("on");
      continueRef.current && continueRef.current.classList.add("on");
      ar.forEach((el, i) => el.classList.remove("on"));
    } else {
      ar.forEach((el, i) => {
        if (num === i) {
          el.classList.add("on");
        } else {
          el.classList.remove("on");
        }
      });
      bookmarkRef.current && bookmarkRef.current.classList.remove("on");
      continueRef.current && continueRef.current.classList.remove("on");
    }
  };

  const onClick = (num) => {
    const wrap = document.querySelector("#scWrap");
    const target =
      num === "bookmark"
        ? document.querySelector(`#bookmarkBox`)
        : num === "continue"
        ? document.querySelector(`#continueBox`)
        : document.querySelector(`#sbox${num}`);
    const wh = window.innerHeight / 2;
    const top = target.offsetTop;
    const scrollCoords = { y: wrap.scrollTop };
    const maxScrollHeight =
      wrap.scrollHeight - wrap.getBoundingClientRect().height;
    let targetScroll = top - (wh - 310);
    if (targetScroll < 0) {
      targetScroll = 0;
    }
    if (targetScroll >= maxScrollHeight) {
      targetScroll = maxScrollHeight;
    }

    if (num === "bookmark") {
      activeClass("bookmark");
    } else if (num === "continue") {
      activeClass("continue");
    } else {
      activeClass(num);
    }

    anime({
      targets: scrollCoords,
      y: targetScroll,
      duration: 500,
      easing: "easeOutCubic",
      update: () => wrap.scrollTo(0, scrollCoords.y),
    });
  };

  const goTop = () => {
    const wrap = document.querySelector("#scWrap");
    const scrollCoords = { y: wrap.scrollTop };
    anime({
      targets: scrollCoords,
      y: 0,
      duration: 500,
      easing: "easeOutCubic",
      update: () => wrap.scrollTo(0, scrollCoords.y),
    });
  };

  return (
    <Wrap id="mainSideBar">
      {continueData ? (
        <BoxWrap>
          <BookmarkBox
            ref={continueRef}
            type="button"
            className="continue-icon"
            onClick={() => onClick("continue")}
          />
        </BoxWrap>
      ) : null}

      {curBookMark.length > 0 ? (
        <BoxWrap>
          <BookmarkBox
            ref={bookmarkRef}
            type="button"
            className="bookmark-icon"
            onClick={() => onClick("bookmark")}
          />
        </BoxWrap>
      ) : null}

      <BoxWrap>
        <Box
          type="button"
          className="rbox"
          color={"#de524b"}
          onClick={() => onClick(0)}
        />
      </BoxWrap>
      <BoxWrap>
        <Box
          type="button"
          className="rbox"
          color={"#e7a500"}
          onClick={() => onClick(1)}
        />
      </BoxWrap>
      <BoxWrap>
        <Box
          type="button"
          className="rbox"
          color={"#edd200"}
          onClick={() => onClick(2)}
        />
      </BoxWrap>
      <BoxWrap>
        <Box
          type="button"
          className="rbox"
          color={"#93bb00"}
          onClick={() => onClick(3)}
        />
      </BoxWrap>
      <BoxWrap>
        <Box
          type="button"
          className="rbox"
          color={"#7eabeb"}
          onClick={() => onClick(4)}
        />
      </BoxWrap>
      <BoxWrap>
        <Box
          type="button"
          className="rbox"
          color={"#253a62"}
          onClick={() => onClick(5)}
        />
      </BoxWrap>
      <BoxWrap>
        <Box
          type="button"
          className="rbox"
          color={"#aa5aef"}
          onClick={() => onClick(6)}
        />
      </BoxWrap>
      <BoxWrap>
        <Box
          type="button"
          className="rbox"
          color={"#cdcdab"}
          onClick={() => onClick(7)}
        />
      </BoxWrap>
      <BoxWrap>
        <GoTop type="button" onClick={() => goTop()} />
      </BoxWrap>
    </Wrap>
  );
};

export default React.memo(MainSideBar);
